import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import classNames from 'classnames'

class Steps extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        totalSteps: PropTypes.number,
    }

    render()
    {
        const { t, currentStep, totalSteps } = this.props

        if(! totalSteps)
        {
            return null
        }

        const items = []
        for (let i = 0; i < totalSteps; i++) {
            items.push(<li key={i} className={classNames('step', { 'active': i+1 === currentStep})}></li>)
        }

        return (
            <div id={"steps"} >
                <div className={'label'}>{t('visualizer:toolbar.left.collaborativeIndexationCreation.form.step.label', {currentStep, totalSteps})}</div>
                <ul>
                {items}
                </ul>
            </div>
        )
    }
}

export default withTranslation()(Steps)
